<template>
    <div>
        <v-card>
            <v-card-title class="text-h5 py-2">
                <v-btn
                    class="mr-3"
                    depressed
                    color="primary"
                    icon
                    rounded
                    @click="closeDialog1()"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>

                <span>{{ title }}</span>
                <v-spacer />

                <!-- Currency View Toggle - Centered between title and Save button -->
                <v-switch
                    v-model="localShowAlternativeView"
                    color="primary"
                    hide-details
                    dense
                    class="mt-0 mx-4"
                >
                    <template v-slot:label>
                        <span class="text-caption">
                            {{
                                localShowAlternativeView
                                    ? `Alternative (${displayCurrencyForSections})`
                                    : `Original (${globalCurrency})`
                            }}
                        </span>
                    </template>
                </v-switch>

                <v-spacer />
                <v-btn
                    v-if="
                        quote &&
                            (quote.status === 'OPEN' ||
                                quote.status === 'APPROVAL') &&
                            !version
                    "
                    :disabled="!validateForm"
                    color="primary"
                    :loading="valueLoading"
                    elevation="0"
                    rounded
                    @click="saveCost"
                    >Save</v-btn
                >
            </v-card-title>

            <v-divider class="mx-4" />

            <v-alert
                dismissible
                v-if="loadingError"
                text
                type="error"
                prominent
            >
                <v-row text-align="center">
                    <v-col class="grow">
                        The exchange data is missing
                    </v-col>
                    <v-col class="shrink">
                        <v-btn color="error" outlined :to="{ name: 'settings' }"
                            >Add Exchange Rate</v-btn
                        >
                    </v-col>
                </v-row>
            </v-alert>

            <v-card-text class="overflow-y-auto" max-height="900">
                <v-row>
                    <v-col cols="12" sm="12" md="6" lg="6" xl="6">
                        <v-form v-model="valid">
                            <v-row no-gutters class="align-center">
                                <v-col
                                    class="d-flex align-center"
                                    cols="4"
                                    sm="2"
                                    md="2"
                                    lg="2"
                                    xl="2"
                                >
                                    <v-subheader>Reference *</v-subheader>
                                </v-col>
                                <v-col cols="8" sm="10" md="10" lg="10" xl="10">
                                    <v-row>
                                        <v-text-field
                                            flat
                                            dense
                                            hide-details
                                            solo
                                            required
                                            :rules="[rules.required]"
                                            class="text-body-2"
                                            v-model="cost.reference"
                                            placeholder="Detailed name of the scope"
                                            :disabled="
                                                (quote &&
                                                    quote.status !== 'OPEN' &&
                                                    quote.status !==
                                                        'APPROVAL') ||
                                                    version ||
                                                    readOnly
                                            "
                                        ></v-text-field>
                                    </v-row>
                                </v-col>
                            </v-row>

                            <v-row no-gutters class="align-center">
                                <v-col
                                    class="d-flex align-center"
                                    cols="4"
                                    sm="2"
                                    md="2"
                                    lg="2"
                                    xl="2"
                                >
                                    <v-subheader>Category *</v-subheader>
                                </v-col>
                                <v-col
                                    class="d-flex align-center"
                                    cols="8"
                                    sm="10"
                                    md="10"
                                    lg="10"
                                    xl="10"
                                >
                                    <v-autocomplete
                                        flat
                                        dense
                                        hide-details
                                        solo
                                        required
                                        placeholder="Cost category for invoicing"
                                        :rules="[rules.required]"
                                        class="text-body-2 ml-n3"
                                        :items="categories"
                                        item-text="name"
                                        item-value="name"
                                        v-model="cost.category"
                                        :disabled="
                                            (quote &&
                                                quote.status !== 'OPEN' &&
                                                quote.status !== 'APPROVAL') ||
                                                version ||
                                                readOnly
                                        "
                                        :style="{ 'max-width': '280px' }"
                                    ></v-autocomplete>
                                </v-col>
                            </v-row>

                            <v-row no-gutters class="d-flex align-center">
                                <v-col
                                    class="d-flex align-center"
                                    cols="4"
                                    sm="2"
                                    md="2"
                                    lg="2"
                                    xl="2"
                                >
                                    <v-subheader>Measure *</v-subheader>
                                </v-col>
                                <v-col cols="8" sm="10" md="10" lg="10" xl="10">
                                    <v-autocomplete
                                        flat
                                        dense
                                        hide-details
                                        solo
                                        required
                                        value="ft2"
                                        :rules="[rules.required]"
                                        class="text-body-2 ml-n3"
                                        :items="units"
                                        @change="setPricePerQ"
                                        v-model="cost.measure"
                                        :disabled="
                                            (quote &&
                                                quote.status !== 'OPEN' &&
                                                quote.status !== 'APPROVAL') ||
                                                version ||
                                                readOnly
                                        "
                                        :style="{ 'max-width': '150px' }"
                                    ></v-autocomplete>
                                </v-col>
                            </v-row>
                            <v-row no-gutters>
                                <v-col cols="4" sm="2" md="2" lg="2" xl="2">
                                    <v-subheader>Units *</v-subheader>
                                </v-col>
                                <v-col cols="8" sm="10" md="10" lg="10" xl="10">
                                    <v-text-field
                                        flat
                                        dense
                                        type="number"
                                        solo
                                        hide-details
                                        class="text-body-2 ml-n3"
                                        required
                                        :rules="[rules.number2]"
                                        placeholder="840"
                                        @input="setPricePerQ"
                                        v-model="cost.quantity"
                                        :disabled="
                                            (quote &&
                                                quote.status !== 'OPEN' &&
                                                quote.status !== 'APPROVAL') ||
                                                version ||
                                                readOnly
                                        "
                                        :style="{ 'max-width': '150px' }"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row class="d-flex align-center" no-gutters>
                                <v-col cols="4" sm="2" md="2" lg="2" xl="2">
                                    <v-subheader>Margin *</v-subheader>
                                </v-col>
                                <v-col cols="8" sm="10" md="10" lg="10" xl="10">
                                    <v-text-field
                                        flat
                                        dense
                                        class="text-body-2 ml-n3"
                                        hide-details
                                        solo
                                        placeholder="44"
                                        type="number"
                                        suffix="%"
                                        required
                                        :rules="[rules.number]"
                                        @input="setTotalMargin"
                                        v-model="cost.margin"
                                        :disabled="
                                            (quote &&
                                                quote.status !== 'OPEN' &&
                                                quote.status !== 'APPROVAL') ||
                                                version ||
                                                readOnly
                                        "
                                        :style="{ 'max-width': '150px' }"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-col>
                    <v-col cols="12" sm="12" md="6" lg="6" xl="6">
                        <v-form v-model="valid2">
                            <v-row class="mt-1" v-if="!version">
                                <v-col class="d-flex align-center" cols="12">
                                    <v-row>
                                        <h4 class="mt-1">
                                            Engineering:
                                        </h4>
                                        <v-btn
                                            v-if="
                                                quote &&
                                                    (quote.status === 'OPEN' ||
                                                        quote.status ===
                                                            'APPROVAL') &&
                                                    engineeringCostPermission &&
                                                    !quote.archive &&
                                                    !version &&
                                                    !cost.engineering &&
                                                    !readOnly &&
                                                    (!cost.preDesign ||
                                                        (cost.preDesign &&
                                                            cost.preDesign
                                                                .length < 1) ||
                                                        (cost.preDesign &&
                                                            cost.preDesign
                                                                .length > 0 &&
                                                            !cost.preDesign[
                                                                cost.preDesign
                                                                    .length - 1
                                                            ].versionNumber &&
                                                            !cost.preDesign[
                                                                cost.preDesign
                                                                    .length - 1
                                                            ].date)) &&
                                                    (cost.id ||
                                                        cost.document_id) &&
                                                    !engineerView
                                            "
                                            :disabled="
                                                quote &&
                                                    !quote.collaborators.includes(
                                                        user.id
                                                    ) &&
                                                    !engineeringCostPermission
                                            "
                                            color="primary"
                                            elevation="0"
                                            small
                                            icon
                                            @click="openEngDueDateDialog"
                                        >
                                            <v-icon>mdi-calendar-edit </v-icon>
                                        </v-btn>
                                        <v-btn
                                            v-else-if="
                                                !cost.document_id && !cost.id
                                            "
                                            :disabled="
                                                quote &&
                                                    !quote.collaborators.includes(
                                                        user.id
                                                    ) &&
                                                    !engineeringCostPermission
                                            "
                                            color="primary"
                                            elevation="0"
                                            small
                                            icon
                                            @click="openEngDueDateDialog"
                                        >
                                            <v-icon>mdi-calendar-edit </v-icon>
                                        </v-btn>
                                        <v-btn
                                            v-else-if="
                                                (cost.id || cost.document_id) &&
                                                    !engineerView
                                            "
                                            style="width: 100px;"
                                            rounded
                                            small
                                            elevation="0"
                                            :color="
                                                cost.preDesign &&
                                                cost.preDesign[
                                                    cost.preDesign.length - 1
                                                ]?.rejectedOn
                                                    ? 'red'
                                                    : cost.engineering &&
                                                      (['', '123'].includes(
                                                          cost.engineer
                                                      ) ||
                                                          !cost.engineer)
                                                    ? 'green'
                                                    : cost.preDesign &&
                                                      cost.preDesign.length >
                                                          0 &&
                                                      !cost.engineering &&
                                                      (cost.preDesign[
                                                          cost.preDesign
                                                              .length - 1
                                                      ].generatedOn ||
                                                          cost.preDesign[
                                                              cost.preDesign
                                                                  .length - 1
                                                          ].date)
                                                    ? 'primary'
                                                    : cost.engineering &&
                                                      ![
                                                          '123',
                                                          undefined,
                                                      ].includes(cost.engineer)
                                                    ? '#ff7800'
                                                    : ''
                                            "
                                            class="text-center btnStatus white--text ml-2"
                                        >
                                            {{
                                                cost.preDesign &&
                                                cost.preDesign[
                                                    cost.preDesign.length - 1
                                                ]?.rejectedOn
                                                    ? 'Rejected'
                                                    : cost.engineering &&
                                                      (['', '123'].includes(
                                                          cost.engineer
                                                      ) ||
                                                          !cost.engineer)
                                                    ? 'Pending'
                                                    : cost.preDesign &&
                                                      cost.preDesign.length >
                                                          0 &&
                                                      !cost.engineering &&
                                                      (cost.preDesign[
                                                          cost.preDesign
                                                              .length - 1
                                                      ].generatedOn ||
                                                          cost.preDesign[
                                                              cost.preDesign
                                                                  .length - 1
                                                          ].date)
                                                    ? 'Done'
                                                    : cost.engineering &&
                                                      ![
                                                          '123',
                                                          undefined,
                                                      ].includes(cost.engineer)
                                                    ? 'Assigned'
                                                    : ''
                                            }}
                                        </v-btn>
                                        <div class="mt-2">
                                            <span class="ml-4">{{
                                                cost &&
                                                cost.engineeringDate &&
                                                cost.engineeringDate._seconds
                                                    ? formatDate(
                                                          cost.engineeringDate
                                                              ._seconds
                                                      )
                                                    : cost.engineeringDate
                                                    ? cost.engineeringDate
                                                    : engineeringDate &&
                                                      !cost.document_id &&
                                                      !cost.id
                                                    ? engineeringDate
                                                    : ''
                                            }}</span>
                                            <v-btn
                                                v-if="
                                                    $router.currentRoute.name !=
                                                        'assign-engineer' &&
                                                        quote &&
                                                        (quote.status ===
                                                            'OPEN' ||
                                                            quote.status ===
                                                                'APPROVAL') &&
                                                        cost.engineering &&
                                                        editEngineeringDueDatePermission &&
                                                        !quote.archive &&
                                                        !engineerView &&
                                                        (cost.document_id ||
                                                            cost.id)
                                                "
                                                :disabled="
                                                    quote &&
                                                        !quote.collaborators.includes(
                                                            user.id
                                                        ) &&
                                                        !editEngineeringDueDatePermission
                                                "
                                                class="ml-2"
                                                color="primary"
                                                elevation="0"
                                                x-small
                                                icon
                                                @click="openEngDueDateDialog"
                                            >
                                                <v-icon
                                                    >mdi-pencil</v-icon
                                                ></v-btn
                                            >
                                        </div>
                                        <div>
                                            <v-btn
                                                v-if="cost.preDesign"
                                                small
                                                @click="seeCostsVersions"
                                                class="ml-2 mt-0"
                                                depressed
                                                rounded
                                                :style="{
                                                    cursor: 'pointer',
                                                }"
                                            >
                                                <v-icon>
                                                    mdi-post-outline
                                                </v-icon>
                                                Log
                                            </v-btn>
                                        </div>
                                    </v-row>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="d-flex align-center" cols="12">
                                    <v-row>
                                        <div class="mt-3">
                                            <h4>
                                                Engineer:
                                            </h4>
                                        </div>
                                        <span class="ml-7 mt-3">{{
                                            cost.engineer
                                                ? getUserName(cost.engineer)
                                                : ''
                                        }}</span>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-form>
                        <v-row
                            v-if="cost.id || cost.document_id"
                            class="d-flex flex-wrap mt-5"
                        >
                            <h4 class="mt-2">Pre-Design:</h4>
                            <div
                                v-for="(item, i) in cost.preDesign || []"
                                :key="i"
                                class="d-flex align-center"
                            >
                                <v-tooltip v-if="item && item.generatedOn" top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <span
                                            class="pa-1 ma-0 mt-1 ml-1 font-weight-bold text-decoration-underline"
                                            v-bind="attrs"
                                            v-on="on"
                                            @click.stop="
                                                openFile(
                                                    item.name ? item.name : ''
                                                )
                                            "
                                            style="font-size: 11px; color: #2b81d6; cursor: pointer;"
                                            >{{
                                                `V${cost.preDesign.findIndex(
                                                    c => c == item
                                                ) + 1}`
                                            }}</span
                                        >
                                    </template>
                                    <span>{{
                                        item.name ? item.name : ''
                                    }}</span>
                                </v-tooltip>
                                <v-tooltip v-else-if="item && item.file" top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <span
                                            class="pa-1 ma-0 mt-1 ml-1 font-weight-bold text-decoration-underline"
                                            v-bind="attrs"
                                            v-on="on"
                                            @click.stop="
                                                item.file
                                                    ? openFile(item.file, true)
                                                    : ''
                                            "
                                            style="font-size: 11px; color: #2b81d6; cursor: pointer;"
                                            >{{
                                                `V${cost.preDesign.findIndex(
                                                    c => c == item
                                                ) + 1}`
                                            }}</span
                                        >
                                    </template>
                                    <span>{{
                                        item.file ? item.file : ''
                                    }}</span>
                                </v-tooltip>
                                <div>
                                    <v-btn
                                        v-if="
                                            item &&
                                                (item.generatedOn ||
                                                    (!item.generatedOn &&
                                                        item.date)) &&
                                                ['OPEN', 'APPROVAL'].includes(
                                                    quote.status
                                                ) &&
                                                !item.rejectedOn &&
                                                !engineerView &&
                                                (engineeringCostPermission ||
                                                    quote.estimatorId ==
                                                        user.id ||
                                                    sendQuote) &&
                                                !cost.engineering
                                        "
                                        @click.stop="
                                            openRejectPreDesignDialog(item)
                                        "
                                        class="ml-1 mt-1"
                                        :style="{
                                            cursor: 'pointer',
                                            color: 'red',
                                        }"
                                        small
                                        rounded
                                        depressed
                                        ><v-icon>mdi-close</v-icon>
                                        Reject
                                    </v-btn>
                                    <v-btn
                                        v-else-if="
                                            item &&
                                                (item.generatedOn ||
                                                    (!item.generatedOn &&
                                                        item.date)) &&
                                                ['OPEN', 'APPROVAL'].includes(
                                                    quote.status
                                                ) &&
                                                item.rejectedOn &&
                                                !engineerView &&
                                                engineeringCostPermission &&
                                                cost.engineering &&
                                                cost.preDesign &&
                                                item.versionNumber ==
                                                    cost.preDesign[
                                                        cost.preDesign.length -
                                                            1
                                                    ].versionNumber
                                        "
                                        @click.stop="
                                            cancelPreDesignRejection(item)
                                        "
                                        class="ml-1 mt-1"
                                        :style="{
                                            cursor: 'pointer',
                                        }"
                                        small
                                        rounded
                                        depressed
                                    >
                                        <v-icon> mdi-arrow-u-down-left</v-icon>
                                        Undo Rejection
                                    </v-btn>
                                </div>
                            </div>
                        </v-row>
                    </v-col>
                </v-row>
                <v-row no-gutters class="align-center">
                    <v-col
                        class="d-flex align-center"
                        cols="4"
                        sm="2"
                        md="2"
                        lg="2"
                        xl="2"
                    >
                        <v-subheader>Product Type</v-subheader>
                    </v-col>
                    <v-col
                        class="d-flex align-center"
                        cols="8"
                        sm="10"
                        md="10"
                        lg="10"
                        xl="10"
                    >
                        <v-autocomplete
                            flat
                            dense
                            hide-details
                            solo
                            required
                            placeholder="Product Type"
                            class="text-body-2 ml-n3"
                            :items="quoteProductTypes"
                            item-text="name"
                            item-value="name"
                            v-model="descriptionType"
                            @change="loadProductTypeDescription"
                            :disabled="
                                (quote &&
                                    quote.status !== 'OPEN' &&
                                    quote.status !== 'APPROVAL') ||
                                    version ||
                                    readOnly
                            "
                            :style="{ 'max-width': '280px' }"
                        ></v-autocomplete>
                    </v-col>
                </v-row>
                <v-row class="d-flex align-start" no-gutters>
                    <v-col cols="4" sm="2" md="2" lg="2" xl="2">
                        <v-subheader>Description</v-subheader>
                    </v-col>
                    <v-col cols="8" sm="10" md="10" lg="10" xl="10">
                        <vue-editor
                            ref="descriptionEditor"
                            :editor-options="editorOptions"
                            class="pt-2 ml-n3"
                            v-model="cost.description"
                            :disabled="
                                (quote &&
                                    quote.status !== 'OPEN' &&
                                    quote.status !== 'APPROVAL') ||
                                    version ||
                                    readOnly
                            "
                            @ready="setupPasteHandler"
                        />
                    </v-col>
                </v-row>
                <v-divider class="my-4" />

                <!--Edit engineering due Date-->
                <v-dialog
                    v-model="engineeringDateDialog"
                    :retain-focus="false"
                    persistent
                    max-width="400"
                >
                    <v-card
                        :loading="valueLoading"
                        v-if="engineeringDateDialog"
                    >
                        <v-card-title class="text-h5">
                            <v-btn
                                small
                                icon
                                @click="closeEngDueDateDialogBtn"
                                color="primary"
                                class="mr-2"
                            >
                                <v-icon>
                                    mdi-close
                                </v-icon>
                            </v-btn>
                            <h3
                                v-if="
                                    cost.engineering &&
                                        (cost.document_id || cost.id)
                                "
                            >
                                Change Eng Due Date
                            </h3>
                            <h3 v-else>
                                Send To Engineering
                            </h3>
                        </v-card-title>
                        <v-divider class="ml-4 mr-5" />
                        <v-card-text class="pt-4">
                            <v-form>
                                <v-row no-gutters>
                                    <v-col cols="12" class="pt-4">
                                        <v-menu
                                            ref="menu"
                                            :close-on-content-click="true"
                                            :nudge-right="40"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="auto"
                                        >
                                            <template
                                                v-slot:activator="{
                                                    on,
                                                    attrs,
                                                }"
                                            >
                                                <v-combobox
                                                    class="py-0 my-0"
                                                    v-model="engineeringDate"
                                                    color="primary"
                                                    label="Eng Due Date"
                                                    readonly
                                                    flat
                                                    hide-details
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    prepend-icon="mdi-calendar-blank-outline"
                                                    :rules="[rules.required]"
                                                ></v-combobox>
                                            </template>
                                            <v-date-picker
                                                v-model="engineeringDate"
                                                scrollable
                                                :min="minDate"
                                            >
                                            </v-date-picker>
                                        </v-menu>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        class="pt-2"
                                        v-if="
                                            !cost.engineering ||
                                                (!cost.document_id && !cost.id)
                                        "
                                    >
                                        <v-autocomplete
                                            v-model="selectedEngineer"
                                            :items="engineerOptions"
                                            :loading="engineersLoading"
                                            item-text="name"
                                            return-object
                                            clearable
                                            hide-details
                                            label="Assign Engineer (optional)"
                                            prepend-icon="mdi-account-hard-hat"
                                        />
                                    </v-col>
                                </v-row>
                            </v-form>
                        </v-card-text>
                        <v-spacer></v-spacer>
                        <v-card-actions class="pb-4">
                            <v-switch
                                v-if="
                                    cost.engineering &&
                                        quote &&
                                        editEngineeringDueDatePermission &&
                                        !quote.archive &&
                                        ['OPEN', 'APPROVAL'].includes(
                                            quote.status
                                        ) &&
                                        !cost.preDesign &&
                                        (cost.document_id || cost.id)
                                "
                                v-model="cancelEngineering"
                                label="Return from Engineering"
                                color="primary"
                                class="my-0 py-0 ml-3"
                                hide-details
                                inset
                                :loading="valueLoading"
                            />
                            <v-spacer />
                            <v-btn
                                color="primary"
                                :loading="valueLoading"
                                rounded
                                :disabled="!engineeringDate"
                                @click="selectAction"
                            >
                                CONFIRM
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>

                <!--Reject Pre-Design-->
                <v-dialog
                    v-model="rejectPreDesignDialog"
                    persistent
                    max-width="600px"
                    :retain-focus="false"
                >
                    <v-card
                        :loading="valueLoading"
                        v-if="rejectPreDesignDialog"
                    >
                        <v-card-title
                            v-if="rejectPreDesignDialog"
                            class="text-h5"
                        >
                            <v-btn
                                small
                                icon
                                @click="closeRejectPreDesignDialog"
                                color="primary"
                                class="mr-2"
                            >
                                <v-icon>
                                    mdi-close
                                </v-icon>
                            </v-btn>
                            Reject Pre-Design</v-card-title
                        >
                        <v-card-text>
                            <strong>Reason:</strong>
                            <v-text-field
                                v-model="selectedPreDesign.rejectionReason"
                                hide-details
                                label="Rejection reason*"
                                :rules="[rules.required]"
                                required
                                class="mb-4
                                "
                            >
                            </v-text-field>
                            <strong>Notes:</strong>
                            <div class="mt-5 mb-15">
                                <vue-editor
                                    ref="editor"
                                    class="mt-2"
                                    :editor-toolbar="customToolbar"
                                    placeholder="Add text content and images here..."
                                    v-model="editorContent"
                                />
                            </div>
                            <strong>Attachments: </strong>
                            <div class="d-flex align-center flex-wrap mt-4">
                                <div
                                    v-for="(file, i) in files"
                                    :key="i"
                                    class="d-flex"
                                >
                                    <v-card
                                        class="d-flex ma-0 ml-2 pa-1 mb-4"
                                        @click="openFileAttached(file.name)"
                                        :style="{ position: 'relative' }"
                                    >
                                        <v-img
                                            class="mb-2 pb-2"
                                            max-width="100px"
                                            max-height="100px"
                                            :src="
                                                file.pdfPreview
                                                    ? file.pdfPreview
                                                    : file.url
                                            "
                                        >
                                        </v-img>
                                        <div>
                                            <v-btn
                                                small
                                                icon
                                                color="red"
                                                elevation="4"
                                                :style="{
                                                    position: 'absolute',
                                                    top: '8px',
                                                    right: '8px',
                                                }"
                                            >
                                                <v-icon
                                                    background
                                                    @click.stop="
                                                        deleteFile(file.name)
                                                    "
                                                >
                                                    mdi-delete
                                                </v-icon>
                                            </v-btn>
                                        </div>
                                    </v-card>
                                </div>
                                <v-btn
                                    @click="onButtonClick"
                                    color="transparent"
                                    elevation="0"
                                    small
                                    class="text-capitalize text--darken-2 mb-4 ml-2"
                                    fab
                                >
                                    <v-icon>mdi-plus</v-icon>
                                </v-btn>
                                <input
                                    ref="uploader2"
                                    class="d-none"
                                    type="file"
                                    accept="application/pdf"
                                    @change="onFileChanged2"
                                />
                            </div>
                        </v-card-text>

                        <v-card-actions>
                            <v-col cols="6" class="pa-0">
                                <v-checkbox
                                    v-model="
                                        selectedPreDesign.rejectedDueToError
                                    "
                                    label="Reprocess due to error."
                                    color="primary"
                                >
                                </v-checkbox>
                            </v-col>
                            <v-spacer />

                            <v-btn
                                @click="validateRejection"
                                color="primary"
                                class="pb-0"
                                :disabled="!selectedPreDesign.rejectionReason"
                                rounded
                                :loading="valueLoading"
                            >
                                REJECT
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>

                <NewCostForm
                    v-for="sec in costsSections"
                    :key="sec.name"
                    @totalCostFunction="totalCost"
                    @saveItems="saveSectionItems"
                    @saveInstallationSectionItems="saveInstallationSectionItems"
                    :quoteCurrency="displayCurrencyForSections"
                    :installationEditable="installationEditable"
                    :quoteExchange="Number(displayExchangeForSections)"
                    :createCost="value"
                    :section="sec"
                    :reload="reload"
                    :itemSections="cost.sections"
                    :settingsExchange="settingExchange"
                    :settingsUnits="settingUnits"
                    :quoteStatus="quote ? quote.status : ''"
                    :version="version"
                    :useAlternativeView="useAlternativeViewInSections"
                    :displayCurrency="displayCurrencyForSections"
                    :displayExchange="displayExchangeForSections"
                />
                <v-simple-table dense class="mb-4">
                    <template v-slot:default>
                        <thead class="grey lighten-3">
                            <tr>
                                <th class="text-center no-border"></th>
                                <th class="text-center no-border">
                                    TOTAL COST
                                </th>
                                <th class="text-center no-border">
                                    MARGIN
                                </th>
                                <th class="text-center no-border">
                                    SALE PRICE
                                </th>
                                <th class="text-center no-border">
                                    COMMISSIONS
                                </th>
                                <th class="text-center no-border">
                                    UNITS
                                </th>
                                <th class="text-center no-border">
                                    PRICE PER UNIT
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <!-- Primera fila: Siempre en COP (globalCurrency) con valores originales -->
                            <tr>
                                <td class="text-center">
                                    {{ globalCurrency }}
                                </td>
                                <td class="text-center">
                                    {{ formatNumber(totalC) }}
                                    {{ globalCurrency }}
                                </td>
                                <td class="text-center">
                                    {{ formatNumber(totalMargin) }}
                                    {{ globalCurrency }}
                                </td>
                                <td class="text-center">
                                    {{ formatNumber(cost.salePrice) }}
                                    {{ globalCurrency }}
                                </td>
                                <td class="text-center">
                                    {{ formatNumber(commission) }}
                                    {{ globalCurrency }}
                                </td>
                                <td class="text-center">{{ cost.quantity }}</td>
                                <td class="text-center">
                                    {{
                                        formatNumber(
                                            cost.pricePerQuantity.toFixed(2)
                                        )
                                    }}
                                    {{ globalCurrency }}/{{
                                        !isOperable
                                            ? cost.measure
                                            : isLength
                                            ? 'm'
                                            : 'm2'
                                    }}
                                </td>
                            </tr>
                            <!-- Segunda fila: Siempre visible, muestra valores convertidos si toggle activo, valores normales si desactivado -->
                            <tr>
                                <td class="text-center">
                                    {{
                                        localShowAlternativeView
                                            ? displayCurrencyForSections
                                            : quoteCurrency
                                    }}
                                </td>
                                <td class="text-center">
                                    {{
                                        formatNumber(
                                            localShowAlternativeView
                                                ? convertedTotalForSummary
                                                : cost.total2
                                        )
                                    }}
                                    {{
                                        localShowAlternativeView
                                            ? displayCurrencyForSections
                                            : quoteCurrency
                                    }}
                                </td>
                                <td class="text-center">
                                    {{
                                        formatNumber(
                                            localShowAlternativeView
                                                ? convertedTotalMarginForSummary
                                                : cost.totalMargin2
                                        )
                                    }}
                                    {{
                                        localShowAlternativeView
                                            ? displayCurrencyForSections
                                            : quoteCurrency
                                    }}
                                </td>
                                <td class="text-center">
                                    {{
                                        formatNumber(
                                            localShowAlternativeView
                                                ? convertedSalePriceForSummary
                                                : cost.salePrice2
                                        )
                                    }}
                                    {{
                                        localShowAlternativeView
                                            ? displayCurrencyForSections
                                            : quoteCurrency
                                    }}
                                </td>
                                <td class="text-center">
                                    {{
                                        formatNumber(
                                            localShowAlternativeView
                                                ? convertedCommissionForSummary
                                                : cost.commission2
                                        )
                                    }}
                                    {{
                                        localShowAlternativeView
                                            ? displayCurrencyForSections
                                            : quoteCurrency
                                    }}
                                </td>
                                <td class="text-center">{{ cost.quantity }}</td>
                                <td class="text-center">
                                    {{
                                        formatNumber(
                                            (localShowAlternativeView
                                                ? convertedPricePerQuantityForSummary
                                                : cost.pricePerQuantity2
                                            ).toFixed(2)
                                        )
                                    }}
                                    {{
                                        localShowAlternativeView
                                            ? displayCurrencyForSections
                                            : quote
                                            ? quote.currency
                                            : quoteCurrency
                                    }}/{{
                                        !isOperable
                                            ? cost.measure
                                            : isLength
                                            ? 'ft'
                                            : 'ft2'
                                    }}
                                </td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
                <v-simple-table dense class="mb-4">
                    <template v-slot:default>
                        <thead class="grey lighten-3">
                            <tr>
                                <th class="text-center no-border"></th>
                                <th class="text-center no-border">
                                    TOTAL WEIGHT
                                </th>
                                <th class="text-center no-border">
                                    WEIGHT PER UNIT
                                </th>
                                <th class="text-center no-border">
                                    COST/WEIGHT
                                </th>
                                <th class="text-center no-border">
                                    PRICE/WEIGHT
                                </th>
                                <th class="text-center no-border">
                                    COST PER UNIT
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>AMERICAN</td>
                                <td class="text-center">
                                    {{ formatNumber(cost.american.tw) }}
                                    lb
                                </td>
                                <td class="text-center">
                                    {{ formatNumber(cost.american.wa) }}
                                    {{
                                        cost.american.wa == 0
                                            ? ''
                                            : `lb/${
                                                  cost.measure === 'qt' ||
                                                  cost.measure === 'QT'
                                                      ? 'qt'
                                                      : isLength
                                                      ? 'ft'
                                                      : 'ft2'
                                              }`
                                    }}
                                </td>
                                <td class="text-center">
                                    {{ formatNumber(convertedAmericanCw) }}
                                    {{ displayCurrencyForSections }}/lb
                                </td>
                                <td class="text-center">
                                    {{ formatNumber(convertedAmericanPw) }}
                                    {{ displayCurrencyForSections }}/lb
                                </td>
                                <td class="text-center">
                                    {{ formatNumber(convertedAmericanCa) }}
                                    {{ displayCurrencyForSections }}/{{
                                        !isOperable
                                            ? cost.measure
                                            : isLength
                                            ? 'ft'
                                            : 'ft2'
                                    }}
                                </td>
                            </tr>
                            <tr>
                                <td>INTERNATIONAL</td>
                                <td class="text-center">
                                    {{ formatNumber(cost.international.tw) }}
                                    kg
                                </td>
                                <td class="text-center">
                                    {{ formatNumber(cost.international.wa) }}
                                    {{
                                        cost.international.wa == 0
                                            ? ''
                                            : `kg/${
                                                  cost.measure === 'qt' ||
                                                  cost.measure === 'QT'
                                                      ? 'qt'
                                                      : isLength
                                                      ? 'm'
                                                      : 'm2'
                                              }`
                                    }}
                                </td>
                                <td class="text-center">
                                    {{ formatNumber(cost.international.cw) }}
                                    COP/kg
                                </td>
                                <td class="text-center">
                                    {{ formatNumber(cost.international.pw) }}
                                    COP/kg
                                </td>
                                <td class="text-center">
                                    {{ formatNumber(cost.international.ca) }}
                                    COP/{{
                                        !isOperable
                                            ? cost.measure
                                            : isLength
                                            ? 'm'
                                            : 'm2'
                                    }}
                                </td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
            </v-card-text>
        </v-card>
        <v-dialog
            :retain-focus="false"
            v-model="dialogSave"
            persistent
            max-width="400px"
        >
            <v-card>
                <v-card-title class="text-h5">Save Cost</v-card-title>
                <v-card-text>
                    Do you want to save the changes?
                </v-card-text>
                <v-card-actions>
                    <v-btn text color="secondary" @click="dontSaveCost">
                        Close
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn @click="saveCost" text color="error">
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--View Versions-->
        <v-dialog
            :retain-focus="false"
            v-model="dialogVersions"
            persistent
            width="980px"
        >
            <RejectionEngineeringTable
                v-if="dialogVersions"
                :quote="quote"
                :users="users"
                :costInfo="cost"
                :items="preDesignView"
                :companyId="companyId"
                :quoteId="quote.id"
                :costId="cost.id || cost.document_id"
                @closeDialogVersions="closeDialogVersions"
                @openFile="openFile"
            />
        </v-dialog>
        <v-dialog
            v-model="engineerDateDialog"
            :retain-focus="false"
            persistent
            max-width="400"
        >
            <v-card :loading="valueLoading" v-if="engineerDateDialog">
                <v-card-title class="text-h5">
                    <v-btn
                        small
                        icon
                        @click="closeEngineerDateDialog"
                        color="primary"
                        class="mr-2"
                    >
                        <v-icon>
                            mdi-close
                        </v-icon>
                    </v-btn>
                    <h3>
                        Change Eng Due Date
                    </h3>
                </v-card-title>
                <v-divider class="ml-4 mr-5" />
                <v-card-text class="pt-4">
                    <v-form>
                        <v-row no-gutters>
                            <v-col cols="12" class="pt-4">
                                <v-menu
                                    ref="menu"
                                    :close-on-content-click="true"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="auto"
                                >
                                    <template
                                        v-slot:activator="{
                                            on,
                                            attrs,
                                        }"
                                    >
                                        <v-combobox
                                            class="py-0 my-0"
                                            v-model="engineeringDate"
                                            color="primary"
                                            label="Eng Due Date"
                                            readonly
                                            flat
                                            hide-details
                                            v-bind="attrs"
                                            v-on="on"
                                            prepend-icon="mdi-calendar-blank-outline"
                                            :rules="[rules.required]"
                                        ></v-combobox>
                                    </template>
                                    <v-date-picker
                                        v-model="engineeringDate"
                                        scrollable
                                        :min="minDate"
                                    >
                                    </v-date-picker>
                                </v-menu>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
                <v-spacer></v-spacer>
                <v-card-actions class="pb-4">
                    <v-spacer />
                    <v-btn
                        color="primary"
                        :loading="valueLoading"
                        rounded
                        :disabled="!engineeringDate"
                        @click="selectActionTwo"
                    >
                        CONFIRM
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-alert
            :type="action.type"
            :color="action.color"
            :style="{ position: 'absolute', bottom: 0, right: 0 }"
            dismissible
            v-if="action.active && action.type == 'error'"
        >
            {{ action.message }}
        </v-alert>
        <Errors />
    </div>
</template>

<script>
import NewCostForm from '@/components/Quotes/NewCostForm'
import { mapActions, mapMutations } from 'vuex'
import convert from 'convert-units'
import API from '@/services/api'
import { objDiff } from '@/helpers/objDiff.js'
import moment from 'moment'
import Errors from '@/components/Layout/Errors.vue'
import { openFile } from '@/services/storage/openFile.js'
import { saveFile } from '@/services/storage/saveFile.js'
import _ from 'lodash'
import { VueEditor } from 'vue2-editor'
import { loadPDFPreview } from '@/components/Timesheets/dailyReport.js'
import { v4 as uuidv4 } from 'uuid'
import { storage } from '@/services/firebase'

export default {
    name: 'NewQuoteCostForm',
    components: {
        VueEditor,
        NewCostForm,
        Errors,
        RejectionEngineeringTable: () =>
            import('@/components/Engineering/RejectionEngineeringTable.vue'),
    },
    props: {
        createCostForm: Boolean,
        editAlternative: Boolean,
        alternative: Boolean,
        title: String,
        value: Boolean,
        quote: Object,
        settings: Array,
        copyCost: Boolean,
        cost: Object,
        originalCost: Object,
        costs: Array,
        loading: Boolean,
        lockView: Boolean,
        version: {
            type: Boolean,
            default() {
                return false
            },
        },
        installationEditable: {
            type: Boolean,
            default() {
                return false
            },
        },
        costExchanges: {
            type: Object,
            default() {
                return undefined
            },
        },
        currency: {
            type: String,
            default() {
                return ''
            },
        },
        exchange: {
            type: Number,
            default() {
                return 1
            },
        },
        action: {
            type: Object,
            default() {
                return {}
            },
        },
        readOnly: {
            type: Boolean,
            default() {
                return false
            },
        },
        engineerView: {
            type: Boolean,
            default() {
                return false
            },
        },
        quoteProductTypes: {
            type: Array,
            default() {
                return []
            },
        },
        engineers: {
            type: Array,
            default() {
                return []
            },
        },
    },
    inject: {
        spreadCosts: {
            from: 'spreadCosts',
            default: null,
        },
    },
    data() {
        return {
            editEngineeringDueDatePermission: false,
            sendQuote: false,
            engineeringCostPermission: false,
            units: [],
            newTotal: 0,
            quoteCurrency: null,
            quoteExchange: null,
            newItem: {},
            dialogSave: false,
            settingExchange: [],
            loadingError: false,
            loading2: false,
            sumCommissions: 0,
            totalWeight: this.cost.tw,
            totalMargin: this.cost.totalMargin,
            total: this.cost.total,
            totalCommission: this.cost.commission,
            costsSections: [],
            preDesignView: [],
            descriptionCost: this.cost.descriptionCost,
            valid: false,
            valid2: false,
            enableSave: false,
            rules: {
                required: v => !!v || 'Required',
                number: v => (v <= 100 && v >= 0) || 'Error',
                number2: v => v > 0 || 'Error',
                string:
                    (v => (typeof v == 'string' && v != '') || !v) || 'Error',
            },
            quantityAmerican: 0,
            quantityInternational: 0,
            isLength: false,
            reload: false,
            isOperable: true,
            categories: [],
            user: {},
            engineeringDialog: false,
            engineeringDateDialog: false,
            sendToEngineering: false,
            returnFromEngineering: null,
            minDate: '',
            engineeringDate: '',
            validation: null,
            localFiles: [],
            companyId: JSON.parse(localStorage.getItem('company')),
            users: [],
            selectedEngineer: null,
            engineerOptions: [],
            engineersLoading: false,
            rejectPreDesignDialog: false,
            selectedPreDesign: {},
            cancelEngineering: false,
            dialogVersions: false,
            editorOptions: {
                theme: 'snow',
                modules: {
                    toolbar: [
                        ['bold', 'italic', 'underline'], // basic styles
                        [{ list: 'bullet' }], // bullet points
                        [{ list: 'ordered' }], // numbered lists
                        [{ color: [] }], // color selector
                        ['clean'], // clear formatting
                    ],
                },
            },
            customToolbar: [
                ['bold'],
                [{ header: 1 }, { header: 2 }],
                [{ list: 'ordered' }, { list: 'bullet' }],
                ['image'],
                ['clean'],
            ],
            editorContent: '',
            files: [],
            localAttachments: [],
            imagesOnBase64: [],
            imagesWithDimensions: [],
            imagesAsFiles: [],
            originalImages: [],
            engineerDateDialog: false,
            previousEngineeringDate: null,
            descriptionType: null,
            selectedCost: {},
            localShowAlternativeView: false,
            globalCurrency: '',
        }
    },
    created() {
        const indexCosts = this.settings.findIndex(u => u.name === 'Quotes')
        this.costsSections = this.settings[indexCosts].costSections
        if (!this.cost.sections) {
            this.cost.sections = []
        }
        this.settings[indexCosts].measureUnits.forEach(x => {
            this.units.push(x.abbr)
        })

        if (this.version) {
            this.quoteCurrency = this.currency
            this.quoteExchange = this.exchange
        } else {
            this.quoteCurrency = this.quote.currency
            this.quoteExchange = this.quote.exchange
        }
        if (this.costExchanges) {
            this.settingExchange = this.costExchanges
        } else {
            const indexExchanges = this.settings.findIndex(
                u => u.name === 'Exchange'
            )
            this.settingExchange = this.settings[indexExchanges]
        }
        this.settingUnits = this.settings[indexCosts]
        this.globalCurrency = this.settingExchange?.globalCurrency || 'COP'
    },
    async mounted() {
        if (this.quote) {
            this.setTotalMargin(this.cost.margin)
        }
        if (this.cost && !(this.cost.id || this.cost.document_id)) {
            delete this.cost.engineer
            delete this.cost.engineering
            delete this.cost.engineeringDate
            delete this.cost.engineeringExitDate
            delete this.cost.preDesignReturned
            delete this.cost.engineeringIngressDate
            delete this.cost.engExitBy
            delete this.cost.engIngressBy
            delete this.cost.productType
        }
        if (this.cost.preDesign) {
            this.cost.preDesign = this.cost.preDesign.filter(
                preDesign => !preDesign.returnedReasons
            )
        }
        if (this.cost.description && this.quoteProductTypes) {
            this.descriptionType =
                this.quoteProductTypes.find(
                    text => text.description == this.cost.description
                )?.name || ''
        }
        const {
            data: { settings },
        } = await API.getSettings()

        const {
            data: { user },
        } = await API.getMyInfo()
        this.user = user
        this.engineeringCostPermission = user.permissions.includes(
            'engineeringCost'
        )
        this.sendQuote = user.permissions.includes('sendQuote')
        this.editEngineeringDueDatePermission = user.permissions.includes(
            'editEngineeringDueDate'
        )
        const invoiceSettings = settings.find(
            setting => setting.name.toLowerCase() == 'invoicing'
        )
        this.categories = invoiceSettings.categories
        // get users
        const {
            data: { users },
        } = await API.getLiteUsers()
        this.users = users
        this.loadData()
    },
    computed: {
        totalC: function() {
            return this.total
        },
        costDiff: function() {
            return objDiff(this.originalCost, this.cost)
        },
        commission: function() {
            return this.totalCommission
        },
        valueLoading: function() {
            return this.loading || this.loading2
        },
        show: {
            get() {
                this.changeStartupStatus()
                return this.value
            },
            set(value) {
                this.$emit('input', value)
            },
        },
        validateForm: function() {
            let diff = objDiff(this.originalCost, this.cost)
            delete diff.pricePerQuantity
            delete diff.pricePerQuantity2
            delete diff.salePrice
            delete diff.salePrice2
            delete diff.preDesign
            delete diff.engineering
            delete diff.engineeringDate
            delete diff.american
            delete diff.international
            delete diff.productType
            return (
                (this.alternative || Object.keys(diff).length > 0) &&
                this.valid &&
                this.cost.sections.find(
                    section => section.items.length > 0 && !this.readOnly
                )
            )
        },
        // Currency to use in sections
        displayCurrencyForSections() {
            if (this.localShowAlternativeView) {
                // Alternative view: determine the opposite currency to globalCurrency
                // If globalCurrency is COP, alternative is USD
                // If globalCurrency is USD, alternative is COP
                return this.globalCurrency === 'COP' ? 'USD' : 'COP'
            }
            // Original view: always in globalCurrency (COP)
            return this.globalCurrency
        },
        // Exchange to use in sections
        displayExchangeForSections() {
            if (this.localShowAlternativeView) {
                // Alternative view: determine which exchange to use
                const oppositeCurrency =
                    this.globalCurrency === 'COP' ? 'USD' : 'COP'

                // If quote.exchange !== 1, use quote.exchange
                if (this.quoteExchange && this.quoteExchange !== 1) {
                    return this.quoteExchange
                }

                // If quote.exchange === 1, find exchange in settings for the opposite currency
                const oppositeExchange = this.settingExchange?.exchanges?.find(
                    ex => ex.currency === oppositeCurrency
                )

                if (this.globalCurrency === 'COP') {
                    // Convert from COP to USD
                    return oppositeExchange
                        ? parseFloat(oppositeExchange.money)
                        : 4100
                } else {
                    // Convert from USD to COP
                    return oppositeExchange
                        ? parseFloat(oppositeExchange.money)
                        : 1
                }
            }
            // Original view: exchange = 1 (no conversion)
            return 1
        },
        // Determine whether to use alternative view in sections
        useAlternativeViewInSections() {
            // Always activate when local toggle is active
            return this.localShowAlternativeView
        },
        // Helper to calculate quantity2 temporarily (similar to convertUnits)
        calculatedQuantity2ForAlternativeView() {
            if (!this.localShowAlternativeView) {
                return this.cost.quantity2 || 0
            }
            // Recalculate quantity2 using convertUnits logic
            const quantity = this.cost.quantity || 0
            if (this.cost.measure == 'qt' || this.cost.measure == 'QT') {
                return quantity
            } else if (
                this.settingUnits?.measureUnits?.find(
                    unit =>
                        unit.abbr == this.cost.measure && unit.measure == 'time'
                )
            ) {
                return quantity
            } else if (
                this.settingUnits?.measureUnits?.find(
                    unit =>
                        unit.abbr == this.cost.measure && unit.measure == 'mass'
                )
            ) {
                return quantity
            } else if (
                this.settingUnits?.measureUnits?.find(
                    unit =>
                        unit.abbr == this.cost.measure &&
                        unit.measure == 'length'
                )
            ) {
                return parseFloat(
                    convert(quantity)
                        .from(this.cost.measure)
                        .to('ft')
                )
            } else {
                return parseFloat(
                    convert(quantity)
                        .from(this.cost.measure)
                        .to('ft2')
                )
            }
        },
        // Converted values for the first table (simulating convertions)
        convertedTotalForSummary() {
            if (!this.localShowAlternativeView) {
                return this.total
            }
            // Similar logic to convertions(): if currency is global and exchange is 1, don't convert
            if (!this.shouldConvertCurrency()) {
                return this.total
            }
            // Convert by dividing by exchange
            return parseFloat(
                (this.total / this.displayExchangeForSections).toFixed(2)
            )
        },
        convertedTotalMarginForSummary() {
            if (!this.localShowAlternativeView) {
                return this.totalMargin
            }
            if (!this.shouldConvertCurrency()) {
                return this.totalMargin
            }
            return parseFloat(
                (this.totalMargin / this.displayExchangeForSections).toFixed(2)
            )
        },
        convertedSalePriceForSummary() {
            if (!this.localShowAlternativeView) {
                return this.cost.salePrice
            }
            if (!this.shouldConvertCurrency()) {
                return this.cost.salePrice
            }
            return parseFloat(
                (this.cost.salePrice / this.displayExchangeForSections).toFixed(
                    2
                )
            )
        },
        convertedCommissionForSummary() {
            if (!this.localShowAlternativeView) {
                return this.totalCommission
            }
            if (!this.shouldConvertCurrency()) {
                return this.totalCommission
            }
            return parseFloat(
                (
                    this.totalCommission / this.displayExchangeForSections
                ).toFixed(2)
            )
        },
        convertedPricePerQuantityForSummary() {
            if (!this.localShowAlternativeView) {
                return this.cost.pricePerQuantity
            }
            const convertedSalePrice = this.convertedSalePriceForSummary
            const quantity2 = this.calculatedQuantity2ForAlternativeView

            if (!this.shouldConvertCurrency()) {
                return this.cost.pricePerQuantity
            }
            // Calcular pricePerQuantity2 usando salePrice2 / quantity2 (similar a convertions)
            return quantity2 > 0
                ? parseFloat((convertedSalePrice / quantity2).toFixed(2))
                : 0
        },
        // American statistics recalculated using converted values (similar to convertAmericanStatistics)
        convertedAmericanCw() {
            if (!this.localShowAlternativeView) {
                return this.cost.american.cw
            }
            const convertedTotal = this.convertedTotalForSummary
            return this.cost.american.tw > 0
                ? parseFloat(
                      (convertedTotal / this.cost.american.tw).toFixed(2)
                  )
                : 0
        },
        convertedAmericanPw() {
            if (!this.localShowAlternativeView) {
                return this.cost.american.pw
            }
            const convertedSalePrice = this.convertedSalePriceForSummary
            return this.cost.american.tw > 0
                ? parseFloat(
                      (convertedSalePrice / this.cost.american.tw).toFixed(2)
                  )
                : 0
        },
        convertedAmericanCa() {
            if (!this.localShowAlternativeView) {
                return this.cost.american.ca
            }
            const convertedTotal = this.convertedTotalForSummary
            const quantity2 = this.calculatedQuantity2ForAlternativeView
            return quantity2 > 0
                ? parseFloat((convertedTotal / quantity2).toFixed(2))
                : 0
        },
    },
    watch: {
        totalC: function(newTotal) {
            this.totalCostAction(newTotal)
        },
        editorContent: async function() {
            this.imagesOnBase64 = this.extractImagesWithMatchAll(
                this.editorContent
            )
        },
        imagesOnBase64: async function(newImages) {
            if (!newImages || newImages.length === 0) return
            try {
                const imagesWithDimensions = await this.getImagesDimensions(
                    newImages
                )
                const filesArray = await this.convertToFiles(
                    imagesWithDimensions
                )
                this.imagesWithDimensions = imagesWithDimensions
                this.imagesAsFiles = filesArray
            } catch (error) {
                console.error('An error has occurred.', error)
            }
        },
    },
    methods: {
        ...mapActions(['totalCostAction', 'quoteChangesAction']),
        ...mapMutations(['setErrorItems']),
        shouldConvertCurrency() {
            return (
                this.displayCurrency !== this.globalCurrency ||
                this.displayExchange !== 1
            )
        },
        extractImagesWithMatchAll(htmlContent) {
            const regex = /<img\s+[^>]*src="([^"]+)"(?:[^>]*data-name="([^"]+)")?[^>]*>/g

            const extractedImages = Array.from(htmlContent.matchAll(regex)).map(
                match => ({
                    base64: match[1],
                    name: match[2] || null,
                })
            )
            return extractedImages
        },
        setupPasteHandler(quill) {
            if (quill._pasteHandlerSetup) return
            quill._pasteHandlerSetup = true

            const Delta = quill.constructor.import('delta')

            quill.root.addEventListener(
                'paste',
                e => {
                    const clipboardData =
                        e.clipboardData || window.clipboardData
                    if (!clipboardData) return

                    const pastedHTML = clipboardData.getData('text/html')
                    const pastedText = clipboardData.getData('text/plain')

                    if (!pastedText) return

                    // Only process if it has bullet points
                    if (
                        !/^[\u2022\u2023\u25E6\u2043\u2219\-*]\s+/m.test(
                            pastedText
                        )
                    )
                        return

                    e.preventDefault()
                    e.stopPropagation()
                    e.stopImmediatePropagation()

                    const range = quill.getSelection(true)
                    let newDelta = new Delta().retain(range.index)
                    const lines = pastedText.split('\n')
                    const tempDiv = document.createElement('div')
                    if (pastedHTML) tempDiv.innerHTML = pastedHTML

                    // Helper function to get HTML element
                    const getHtmlElement = text => {
                        const elements = tempDiv.querySelectorAll('p, div, li')
                        for (const el of elements) {
                            if (el.textContent.trim() === text) return el
                        }
                        return null
                    }

                    // Helper function to preserve HTML formatting (without list format)
                    const insertWithFormat = (text, htmlElement) => {
                        if (htmlElement && pastedHTML) {
                            const delta = quill.clipboard.convert(
                                htmlElement.outerHTML
                            )
                            delta.ops.forEach(op => {
                                if (
                                    typeof op.insert === 'string' &&
                                    op.insert !== '\n'
                                ) {
                                    const attrs = { ...(op.attributes || {}) }
                                    delete attrs.list
                                    newDelta.insert(
                                        op.insert,
                                        Object.keys(attrs).length > 0
                                            ? attrs
                                            : undefined
                                    )
                                }
                            })
                        } else {
                            newDelta.insert(text)
                        }
                    }

                    lines.forEach((line, index) => {
                        const trimmed = line.trim()
                        const nextLine =
                            index < lines.length - 1 ? lines[index + 1] : null
                        const hasEmptyLineAfter =
                            nextLine !== null && !nextLine.trim()

                        // Empty line
                        if (!trimmed) {
                            if (
                                hasEmptyLineAfter ||
                                (index < lines.length - 1 && !nextLine.trim())
                            ) {
                                newDelta.insert('\n')
                            }
                            return
                        }

                        // Detect bullet point
                        const bulletMatch = trimmed.match(
                            /^[\u2022\u2023\u25E6\u2043\u2219\-*]\s+(.+)$/
                        )

                        if (bulletMatch) {
                            // It's a bullet - remove bullet from HTML and preserve formatting
                            const contentText = bulletMatch[1]
                            const htmlElement = getHtmlElement(trimmed)

                            if (htmlElement && pastedHTML) {
                                const walker = document.createTreeWalker(
                                    htmlElement,
                                    NodeFilter.SHOW_TEXT,
                                    null
                                )
                                const textNode = walker.nextNode()
                                if (textNode) {
                                    const original = textNode.textContent
                                    const match = original.match(
                                        /^([\u2022\u2023\u25E6\u2043\u2219\-*]\s*)/
                                    )
                                    if (match) {
                                        textNode.textContent = original.substring(
                                            match[1].length
                                        )
                                    }

                                    const delta = quill.clipboard.convert(
                                        htmlElement.outerHTML
                                    )
                                    delta.ops.forEach(op => {
                                        if (
                                            typeof op.insert === 'string' &&
                                            op.insert !== '\n'
                                        ) {
                                            newDelta.insert(
                                                op.insert,
                                                op.attributes || {}
                                            )
                                        }
                                    })

                                    textNode.textContent = original
                                }
                            } else {
                                newDelta.insert(contentText)
                            }

                            newDelta.insert('\n', { list: 'bullet' })
                        } else {
                            // Not a bullet
                            insertWithFormat(trimmed, getHtmlElement(trimmed))

                            // Only add line break if there's an empty line after
                            if (hasEmptyLineAfter) {
                                newDelta.insert('\n')
                            }
                        }
                    })

                    quill.updateContents(newDelta, 'user')
                    quill.setSelection(range.index + newDelta.length())
                },
                true
            )
        },
        loadProductTypeDescription() {
            if (
                this.descriptionType &&
                this.quoteProductTypes &&
                this.quoteProductTypes.length > 0
            ) {
                const selectedProductType = this.quoteProductTypes.find(
                    pt => pt.name === this.descriptionType
                )
                if (selectedProductType && selectedProductType.description) {
                    this.cost.description = selectedProductType.description
                }
            }
        },
        async openFileAttached(file) {
            try {
                this.loading2 = true
                const localFile = this.localAttachments.find(
                    f => f.name == file
                )

                if (localFile) {
                    const url = URL.createObjectURL(localFile)
                    window.open(url, '_blank')
                }
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading2 = false
            }
        },
        async deleteFile(file) {
            try {
                this.loading2 = true
                const checkFile = this.files.find(f => f.name == file)
                if (checkFile) {
                    this.localAttachments = this.localAttachments.filter(
                        f => f.name != file
                    )
                    this.files = this.files.filter(f => f.name != file)
                }
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading2 = false
            }
        },
        onButtonClick() {
            this.$refs.uploader2.click()
        },
        async onFileChanged2(e) {
            await this.saveFile2(e.target.files[0])
        },
        async saveFile2(file) {
            try {
                this.loading2 = true
                const lastDotIndex = file.name.lastIndexOf('.')
                const baseName =
                    lastDotIndex !== -1
                        ? file.name.slice(0, lastDotIndex)
                        : file.name
                const ext =
                    lastDotIndex !== -1 ? file.name.slice(lastDotIndex + 1) : ''
                let newName = file.name
                let counter = 1
                const existingNames = this.files
                    ? this.files.map(att => att.name)
                    : []

                while (existingNames.includes(newName)) {
                    newName = ext
                        ? `${baseName}(${counter}).${ext}`
                        : `${baseName}(${counter})`
                    counter++
                }
                const newFile = new File([file], newName, { type: file.type })
                this.localAttachments.push(newFile)

                if (newFile.name.includes('.pdf')) {
                    newFile.pdfPreview = await loadPDFPreview(
                        URL.createObjectURL(newFile)
                    )
                }
                if (!this.files) {
                    this.files = [
                        {
                            name: newFile.name,
                            url: URL.createObjectURL(newFile),
                            ...(newFile.pdfPreview
                                ? { pdfPreview: newFile.pdfPreview }
                                : {}),
                            newFile: true,
                        },
                    ]
                } else {
                    this.files.push({
                        name: newFile.name,
                        url: URL.createObjectURL(newFile),
                        ...(newFile.pdfPreview
                            ? { pdfPreview: newFile.pdfPreview }
                            : {}),
                        newFile: true,
                    })
                }
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading2 = false
            }
        },
        async saveFile(preDesign, file) {
            try {
                this.loading2 = true
                await API.addPreDesign({
                    quoteId: this.quote.id,
                    costId: this.cost.id,
                    preDesign: { file: preDesign.file, date: preDesign.date },
                })
                await saveFile(
                    file,
                    `${this.companyId}/quotes/${this.quote.id}/costs/${this.cost.id}`
                )
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading2 = false
            }
        },
        async onFileChanged(e) {
            try {
                this.loading2 = true
                if (e.target.files.length > 0) {
                    let file = e.target.files[0]
                    file = new File(
                        [file],
                        moment().format('YYYY-MM-DD HH:mm:ss ') + file.name,
                        {
                            type: file.type,
                        }
                    )
                    const newFile = {
                        file: file.name,
                        date: new Date(),
                        userId: this.user.id,
                    }
                    if (this.cost.preDesign) {
                        this.$set(this.cost, 'preDesign', [
                            ...this.cost.preDesign,
                            newFile,
                        ])
                        this.$emit('updateCostInLocal', this.cost)
                    } else {
                        this.$set(this.cost, 'preDesign', [newFile])
                    }
                    if (!this.cost.id) {
                        this.localFiles = [
                            ...this.localFiles,
                            {
                                url: URL.createObjectURL(file),
                                file,
                            },
                        ]
                    } else {
                        await this.saveFile(newFile, file)
                    }
                }
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading2 = false
            }
        },
        async openFile(fileName, oldVersion) {
            try {
                if (!this.cost.id && !this.cost.document_id) {
                    const file = this.localFiles.find(
                        item => item.file.name == fileName
                    )
                    if (file) {
                        window.open(file.url, '_blank')
                    }
                } else if (!oldVersion) {
                    await openFile(
                        fileName,
                        `${this.companyId}/quotes/${this.quote.id}/costs/${this
                            .cost.id || this.cost.document_id}/preDesigns`
                    )
                } else if (oldVersion) {
                    await openFile(
                        fileName,
                        `${this.companyId}/quotes/${this.quote.id}/costs/${this
                            .cost.id || this.cost.document_id}`
                    )
                }
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading2 = false
            }
        },
        changeStartupStatus() {
            this.reload = !this.reload
        },
        async selectActionTwo() {
            const newEngineeringDate = this.engineeringDate
            this.engineerDateDialog = false
            this.previousEngineeringDate = null
            await this.rejectPreDesign(newEngineeringDate)
        },
        closeEngineerDateDialog() {
            this.engineerDateDialog = false
            if (this.previousEngineeringDate !== null) {
                this.engineeringDate = this.previousEngineeringDate
                this.previousEngineeringDate = null
            }
        },
        selectAction() {
            if (this.cost.engineering === true) {
                if (this.cancelEngineering) {
                    this.unSetEngineering()
                } else {
                    this.changeEngDueDate({
                        item: this.cost,
                        engineeringDate: this.engineeringDate,
                    })
                }
            } else if (this.cost.document_id || this.cost.id) {
                this.setEngineering()
            } else {
                this.cost.engineeringDate = this.engineeringDate
                if (this.selectedEngineer) {
                    this.cost.engineer = this.selectedEngineer.id
                } else {
                    delete this.cost.engineer
                }
            }

            this.engineeringDateDialog = false
        },
        totalCost(parcial, sectionName, totalW) {
            if (
                !this.cost.totalSections ||
                !Array.isArray(this.cost.totalSections)
            ) {
                this.cost.totalSections = []
            }
            let needsRecalculation = false
            if (
                this.cost.totalSections.length === 0 ||
                this.cost.sections.length !== this.cost.totalSections.length
            ) {
                needsRecalculation = true
            } else {
                for (const section of this.cost.sections) {
                    if (section.items && section.items.length > 0) {
                        const existingTotal = this.cost.totalSections.find(
                            ts => ts.secName === section.name
                        )
                        if (!existingTotal || existingTotal.total === 0) {
                            const calculatedTotal = section.items.reduce(
                                (sum, item) => sum + (item.parcial || 0),
                                0
                            )
                            if (calculatedTotal > 0) {
                                needsRecalculation = true
                                break
                            }
                        }
                    }
                }
            }
            if (needsRecalculation) {
                this.cost.totalSections = this.recalculateTotalSectionsFromSections()
            }
            const indexSection = this.cost.totalSections.findIndex(
                element =>
                    element.secName.toLowerCase() === sectionName.toLowerCase()
            )
            this.newItem = {
                secName: sectionName,
                total: parcial,
                totalW: totalW,
            }
            if (indexSection >= 0) {
                this.cost.totalSections.splice(indexSection, 1, this.newItem)
            } else {
                this.cost.totalSections.push(this.newItem)
            }
            this.total = 0
            this.totalWeight = 0
            this.cost.totalSections.forEach(element => {
                this.total +=
                    element.secName !== 'Engineering & Desing'
                        ? element.total
                        : 0
                this.totalWeight +=
                    element.secName !== 'Engineering & Desing'
                        ? element.totalW
                        : 0
            })
            this.cost.total = this.total
            this.cost.international.tw = this.totalWeight
            this.cost.american.tw = parseFloat(this.totalWeight * 2.20462)
            this.setTotalMargin(this.cost.margin)
            this.setPricePerQ(this.cost.quantity)
        },

        recalculateTotalSectionsFromSections() {
            const newTotalSections = []
            if (this.cost.sections && Array.isArray(this.cost.sections)) {
                for (const section of this.cost.sections) {
                    let totalSection = {
                        secName: section.name,
                        total: 0,
                        totalW: 0,
                    }
                    if (section.items && section.items.length > 0) {
                        for (const item of section.items) {
                            totalSection.total += item.parcial || 0
                            totalSection.totalW += item.totalWeight || 0
                        }
                    }
                    newTotalSections.push(totalSection)
                }
            }
            return newTotalSections
        },
        setTotalMargin(event) {
            if (this.cost.total != undefined) {
                if (this.quote.commissions) {
                    if (this.quote.commissions.length > 0) {
                        this.sumCommissions = 0
                        this.quote.commissions.forEach(x => {
                            this.sumCommissions += parseFloat(x.percentage)
                        })
                    }
                }
                const marginp = Number(event) / 100
                const salesPrice1 = Number(this.cost.total) / (1 - marginp)
                // const salesPrice2 =
                //     salesPrice1 *
                //     (Number(this.cost.exportTariff ? 0 : this.sumCommissions) /
                //         100)
                this.totalCommission =
                    salesPrice1 /*+ salesPrice2*/ *
                    (Number(this.cost.exportTariff ? 0 : this.sumCommissions) /
                        100)
                this.cost.commission = parseFloat(Number(this.totalCommission))
                this.totalMargin =
                    salesPrice1 -
                    /*salesPrice2 -
                    this.totalCommission */ Number(
                        this.cost.total
                    )
                this.cost.totalMargin = parseFloat(Number(this.totalMargin))
                this.cost.salePrice = parseFloat(
                    salesPrice1 /*+ salesPrice2*/ + this.totalCommission
                )
                this.cost.total2 = parseFloat(
                    this.cost.total / Number(this.quoteExchange)
                )
                this.cost.totalMargin2 = parseFloat(
                    this.cost.totalMargin / Number(this.quoteExchange)
                )
                this.cost.salePrice2 = parseFloat(
                    this.cost.salePrice / Number(this.quoteExchange)
                )
                this.cost.commission2 = parseFloat(
                    this.cost.commission / Number(this.quoteExchange)
                )

                this.convertUnits(this.cost.quantity)

                this.cost.pricePerQuantity =
                    this.quantityInternational !== 0
                        ? parseFloat(
                              this.cost.salePrice / this.quantityInternational
                          )
                        : 0

                this.cost.pricePerQuantity2 =
                    this.cost.quantity2 !== 0
                        ? parseFloat(this.cost.salePrice2 / this.cost.quantity2)
                        : 0

                this.setAmericanStatistics()
                this.setInternationalStatistics()
            }
        },
        closeDialog: function() {
            this.enableSave = false
            this.totalMargin = 0
            this.totalCommission = 0
            if (this.cost) {
                this.cost.totalSections = []
            }
            this.$emit('closeDialog')
        },
        closeDialog1: function() {
            if (this.engineerView || this.readOnly) {
                this.closeDialog()
            } else {
                if (this.costDiff) {
                    if (
                        Object.entries(this.costDiff).length == 0 ||
                        this.quote.status !== 'OPEN'
                    ) {
                        this.closeDialog()
                    } else {
                        this.dialogSave = true
                    }
                } else {
                    if (this.version) {
                        this.dialogSave = false
                        this.closeDialog()
                    } else {
                        this.total = 0
                        if (this.cost) {
                            this.cost.totalSections = []
                        }
                        this.dialogSave = true
                    }
                }
            }
        },
        seeCostsVersions() {
            if (this.cost.preDesign) {
                this.preDesignView = _.cloneDeep(
                    this.cost.preDesign.filter(file => file.rejectedOn)
                )
            }
            this.dialogVersions = true
        },
        closeDialogVersions() {
            this.dialogVersions = false
            this.preDesignView = []
        },
        setPricePerQ(event) {
            if (isNaN(parseFloat(event))) {
                event = this.cost.quantity
            }
            this.convertUnits(event)
            if (this.quote.commissions) {
                if (this.quote.commissions.length > 0) {
                    this.sumCommissions = 0
                    this.quote.commissions.forEach(x => {
                        this.sumCommissions += parseFloat(x.percentage)
                    })
                }
            }

            this.cost.pricePerQuantity =
                this.quantityInternational > 0
                    ? parseFloat(
                          this.cost.salePrice / this.quantityInternational
                      )
                    : 0
            this.cost.pricePerQuantity2 =
                this.cost.quantity2 > 0
                    ? parseFloat(this.cost.salePrice2 / this.cost.quantity2)
                    : 0

            this.convertToQuoteCurrency()
            this.setAmericanStatistics()
            this.setInternationalStatistics()
        },
        setAmericanStatistics() {
            if (this.cost.american.tw > 0) {
                this.cost.american.cw = parseFloat(
                    (this.cost.total2 / this.cost.american.tw).toFixed(2)
                )
                this.cost.american.pw = parseFloat(
                    (this.cost.salePrice2 / this.cost.american.tw).toFixed(2)
                )
            }
            if (this.cost.quantity > 0) {
                if (this.cost.american.tw > 0) {
                    this.cost.american.wa = parseFloat(
                        (this.cost.american.tw / this.cost.quantity2).toFixed(2)
                    )
                }
                this.cost.american.ca = parseFloat(
                    (this.cost.total2 / this.cost.quantity2).toFixed(2)
                )
            }
            if (this.cost.american.tw === 0) {
                this.cost.american.wa = 0
                this.cost.american.cw = 0
                this.cost.american.pw = 0
            }
        },
        setInternationalStatistics() {
            if (this.cost.international.tw > 0) {
                this.cost.international.cw = parseFloat(
                    (this.cost.total / this.cost.international.tw).toFixed(2)
                )
                this.cost.international.pw = parseFloat(
                    (this.cost.salePrice / this.cost.international.tw).toFixed(
                        2
                    )
                )
            }

            if (this.cost.quantity > 0) {
                if (this.cost.international.tw > 0) {
                    this.cost.international.wa = parseFloat(
                        (
                            this.cost.international.tw /
                            this.quantityInternational
                        ).toFixed(2)
                    )
                }
                this.cost.international.ca = parseFloat(
                    (this.cost.total / this.quantityInternational).toFixed(2)
                )
            }

            if (this.cost.international.tw === 0) {
                this.cost.international.wa = 0
                this.cost.international.cw = 0
                this.cost.international.pw = 0
            }
        },
        convertToQuoteCurrency() {
            if (this.quote.currency != this.globalCurrency) {
                this.cost.total2 = parseFloat(
                    (this.total / this.quoteExchange).toFixed(2)
                )
                this.cost.totalMargin2 = parseFloat(
                    (this.totalMargin / this.quote.exchange).toFixed(2)
                )
                this.cost.salePrice2 = parseFloat(
                    (this.cost.salePrice / this.quote.exchange).toFixed(2)
                )
                this.cost.commission2 = parseFloat(
                    (this.cost.commission / this.quote.exchange).toFixed(2)
                )
                this.cost.pricePerQuantity2 = parseFloat(
                    this.cost.salePrice2 / this.cost.quantity2
                )
            } else {
                this.cost.total2 = this.total
                this.cost.totalMargin2 = this.totalMargin
                this.cost.salePrice2 = this.cost.salePrice
                this.cost.commission2 = this.cost.commission
                this.cost.pricePerQuantity2 = parseFloat(
                    this.cost.salePrice / this.cost.quantity2
                )
            }
        },
        makeid() {
            var length = 6
            var result = ''
            var characters =
                'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
            var charactersLength = characters.length
            for (var i = 0; i < length; i++) {
                result += characters.charAt(
                    Math.floor(Math.random() * charactersLength)
                )
            }
            return result.toUpperCase()
        },
        dontSaveCost() {
            this.dialogSave = false
            this.closeDialog()
        },
        async saveCost() {
            try {
                this.descriptionCost = ''
                this.cost.sections.forEach(element => {
                    for (const i of element.items) {
                        if (this.descriptionCost) {
                            this.descriptionCost =
                                this.descriptionCost + ',' + i.name
                        } else {
                            this.descriptionCost = i.name
                        }
                    }
                })
                this.cost.descriptionCost = this.descriptionCost
                this.descriptionCost = null
                if (this.costs) {
                    const indexCost = this.costs.findIndex(
                        element => element.id == this.cost.id
                    )

                    if (indexCost >= 0) {
                        this.costs.splice(indexCost, 1, this.cost)
                    }
                }
                this.quoteChangesAction(false)
                if (this.alternative) {
                    await this.$emit(
                        'saveAlternative',
                        this.cost,
                        this.localFiles
                    )
                } else if (this.editAlternative) {
                    await this.$emit('updateAlternativeCosts')
                } else {
                    if (this.createCostForm) {
                        await this.$emit('createCosts', this.localFiles)
                    } else {
                        await this.$emit('updateCosts', this.cost)
                    }
                }
                this.totalMargin = 0
                this.totalCommission = 0
                this.sendToEngineering = false
                this.returnFromEngineering = false
                this.dialogSave = false
            } catch (error) {
                console.error(error)
            }
        },
        saveSectionItems(sectionName, sectionItems) {
            if (sectionName === 'Engineering & Desing') return
            const section = { name: sectionName, items: sectionItems }
            const indexSection = this.cost.sections.findIndex(
                element => element.name === sectionName
            )
            if (indexSection >= 0) {
                this.cost.sections.splice(indexSection, 1, section)
            } else {
                this.cost.sections.push(section)
            }
            const sectionTotal = sectionItems.reduce(
                (sum, item) => sum + (item.parcial || 0),
                0
            )
            const sectionTotalW = sectionItems.reduce(
                (sum, item) => sum + (item.totalWeight || 0),
                0
            )
            if (
                !this.cost.totalSections ||
                !Array.isArray(this.cost.totalSections)
            ) {
                this.cost.totalSections = this.recalculateTotalSectionsFromSections()
            }
            const totalSectionIndex = this.cost.totalSections.findIndex(
                ts => ts.secName === sectionName
            )
            const newTotalSection = {
                secName: sectionName,
                total: sectionTotal,
                totalW: sectionTotalW,
            }
            if (totalSectionIndex >= 0) {
                this.cost.totalSections.splice(
                    totalSectionIndex,
                    1,
                    newTotalSection
                )
            } else {
                this.cost.totalSections.push(newTotalSection)
            }
        },
        async saveInstallationSectionItems(sectionName, sectionItemId) {
            try {
                if (sectionName === 'Engineering & Desing') return
                const indexSection = this.cost.sections.findIndex(
                    element => element.name === sectionName
                )
                if (indexSection >= 0) {
                    const section = this.cost.sections[indexSection]
                    if (!section.items) return
                    const indexItem = section.items.findIndex(
                        item => item.id === sectionItemId
                    )
                    this.cost.sections = this.originalCost.sections
                    if (indexItem !== -1) {
                        if ('installation' in section.items[indexItem]) {
                            this.cost.sections[indexSection].items[
                                indexItem
                            ].installation = true
                        } else {
                            delete this.cost.sections[indexSection].items[
                                indexItem
                            ].installation
                        }
                    }
                    await this.$emit('updateCostsInstallation', this.cost)
                }
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            }
        },
        convertUnits(quantity) {
            if (this.cost.measure == 'qt' || this.cost.measure == 'QT') {
                this.isOperable = false
                this.cost.quantity2 = quantity
                this.quantityInternational = quantity
            } else if (
                this.settingUnits.measureUnits.find(
                    unit =>
                        unit.abbr == this.cost.measure && unit.measure == 'time'
                )
            ) {
                this.isOperable = false
                this.cost.quantity2 = quantity
                this.quantityInternational = quantity
            } else if (
                this.settingUnits.measureUnits.find(
                    unit =>
                        unit.abbr == this.cost.measure && unit.measure == 'mass'
                )
            ) {
                this.isOperable = false
                this.cost.quantity2 = quantity
                this.quantityInternational = quantity
            } else if (
                this.settingUnits.measureUnits.find(
                    unit =>
                        unit.abbr == this.cost.measure &&
                        unit.measure == 'length'
                )
            ) {
                this.isOperable = true
                this.isLength = true
                this.cost.quantity2 = parseFloat(
                    convert(quantity)
                        .from(this.cost.measure)
                        .to('ft')
                )
                this.quantityInternational = parseFloat(
                    convert(quantity)
                        .from(this.cost.measure)
                        .to('m')
                )
            } else {
                this.isOperable = true
                this.isLength = false
                this.cost.quantity2 = parseFloat(
                    convert(quantity)
                        .from(this.cost.measure)
                        .to('ft2')
                )
                this.quantityInternational = parseFloat(
                    convert(quantity)
                        .from(this.cost.measure)
                        .to('m2')
                )
            }
        },
        openRejectPreDesignDialog(item) {
            this.selectedCost = this.cost
            if (item.versionNumber) {
                this.selectedPreDesign = this.cost.preDesign.find(
                    doc => doc.versionNumber == item.versionNumber
                )
            } else {
                this.selectedPreDesign = this.cost.preDesign.find(
                    doc => doc.date == item.date
                )
                const index = this.cost.preDesign.findIndex(
                    preDesign => preDesign.file == item.file
                )
                this.selectedPreDesign.versionNumber = index + 1
            }
            this.$set(this.selectedPreDesign, 'rejectedDueToError', false)
            this.rejectPreDesignDialog = true
        },
        closeRejectPreDesignDialog() {
            this.selectedCost = {}
            this.selectedPreDesign = {}
            this.rejectPreDesignDialog = false
            this.editorContent = ''
            this.files = []
            this.localAttachments = []
            this.imagesOnBase64 = []
            this.imagesWithDimensions = []
            this.imagesAsFiles = []
            this.originalImages = []
        },
        async openEngDueDateDialog() {
            this.engineeringDateDialog = true
            const isSendMode =
                !this.cost.engineering ||
                (!this.cost.document_id && !this.cost.id)
            if (isSendMode && this.engineerOptions.length === 0) {
                try {
                    this.engineersLoading = true
                    if (this.engineers.length > 0) {
                        this.engineerOptions = this.engineers
                    } else {
                        const {
                            data: { users },
                        } = await API.getUsers()
                        this.engineerOptions = users.filter(
                            u =>
                                u.permissions &&
                                u.permissions.includes('uploadPreDesign')
                        )
                    }
                } catch (e) {
                    this.setErrorItems({
                        source: this.$options.name,
                        message: e.message,
                    })
                } finally {
                    this.engineersLoading = false
                }
            }
            if (
                isSendMode &&
                this.cost.engineer &&
                this.engineerOptions.length > 0
            ) {
                this.selectedEngineer =
                    this.engineerOptions.find(
                        u => u.id === this.cost.engineer
                    ) || null
            }
        },
        closeEngDueDateDialogBtn() {
            if (this.cost.engineering == this.originalCost.engineering) {
                this.cost.engineeringDate =
                    this.originalCost.engineeringDate &&
                    this.originalCost.engineeringDate._seconds
                        ? this.formatDate(
                              this.originalCost.engineeringDate._seconds
                          )
                        : this.originalCost.engineeringDate
                        ? this.originalCost.engineeringDate
                        : ''

                this.engineeringDate =
                    this.cost.engineeringDate &&
                    this.cost.engineeringDate._seconds
                        ? this.formatDate(this.cost.engineeringDate._seconds)
                        : this.cost.engineeringDate
                        ? this.cost.engineeringDate
                        : ''
                this.sendToEngineering = !this.sendToEngineering
            }
            if (!this.cost.document_id && !this.cost.id) {
                delete this.cost.engineeringDate
                delete this.cost.engineer
                this.engineeringDate = ''
            }

            this.selectedEngineer = null
            this.cancelEngineering = false
            this.engineeringDateDialog = false
        },

        formatDate(seconds) {
            return moment.unix(seconds).format('YYYY-MM-DD')
        },
        loadData() {
            this.engineeringDate = this.cost.engineeringDate?._seconds
                ? this.formatDate(this.cost.engineeringDate._seconds)
                : this.cost.engineeringDate
                ? this.cost.engineeringDate
                : ''
            this.minDate = new Date().toISOString()
            if (this.costs && this.quote) {
                this.costs.forEach(cost => (cost.quoteId = this.quote.id))
            }
            this.cost.quoteId = this.quote ? this.quote.id : ''
        },
        async setEngineering() {
            try {
                this.loading2 = true
                const body = {
                    engineering: true,
                    engineeringDate: this.engineeringDate,
                }
                if (this.selectedEngineer) {
                    body.engineer = this.selectedEngineer.id
                }
                const cost = await API.forEngineering(
                    this.cost.quoteId
                        ? this.cost.quoteId
                        : this.quote.id
                        ? this.quote.id
                        : '',
                    this.cost.document_id
                        ? this.cost.document_id
                        : this.cost.id
                        ? this.cost.id
                        : '',
                    body
                )
                this.cost.engineering = true
                this.cost.engineeringDate = cost.engineeringDate
                    ? cost.engineeringDate
                    : ''
                if (cost.engineer) {
                    this.cost.engineer = cost.engineer
                }

                delete cost.engineeringIngressDate
                delete cost.engineeringExitDate
                delete cost.preDesignReturned
                delete cost.engIngressBy
                delete cost.engExitBy
                if (this.costs) {
                    let index = this.costs.findIndex(c => c.id === cost.id)
                    if (index !== -1) {
                        this.costs.splice(index, 1, {
                            ...this.costs[index],
                            ...cost,
                        })
                    }

                    this.cost.engineering = true
                    this.$emit('updateCostInLocal', this.cost)
                    this.spreadCosts(_.cloneDeep(this.costs))
                } else {
                    this.cost.engineering = true
                    this.$emit('updateCost', this.cost)
                }
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.selectedEngineer = null
                this.loading2 = false
            }
        },
        async unSetEngineering() {
            try {
                this.loading2 = true
                const cost = await API.returnEngineering(
                    this.cost.quoteId
                        ? this.cost.quoteId
                        : this.quote.id
                        ? this.quote.id
                        : '',
                    this.cost.document_id
                        ? this.cost.document_id
                        : this.cost.id
                        ? this.cost.id
                        : '',
                    {
                        engineering: false,
                        engExitBy: this.user.id,
                    }
                )
                delete cost.engineeringIngressDate
                delete cost.engineeringExitDate
                delete cost.preDesignReturned
                delete cost.engExitBy
                delete cost.engIngressBy
                this.cost.engineeringDate = cost.engineeringDate
                this.cost.engineer = ''
                if (this.costs) {
                    let index = this.costs.findIndex(c => c.id === cost.costId)
                    if (index !== -1) {
                        this.costs.splice(index, 1, {
                            ...this.costs[index],
                            ...cost,
                            engineer: '',
                        })
                    }
                    this.cost.engineering = false
                    this.$emit('updateCostInLocal', this.cost)
                    this.spreadCosts(_.cloneDeep(this.costs))
                } else {
                    this.cost.engineering = false
                    this.$emit('updateCost', cost)
                }
                this.cancelEngineering = false
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading2 = false
            }
        },
        async changeEngDueDate() {
            try {
                this.loading2 = true
                let cost = await API.changeEngDueDate(
                    this.cost.quoteId
                        ? this.cost.quoteId
                        : this.quote.id
                        ? this.quote.id
                        : '',
                    this.cost.document_id
                        ? this.cost.document_id
                        : this.cost.id
                        ? this.cost.id
                        : '',
                    {
                        engineeringDate: this.engineeringDate
                            ? this.engineeringDate
                            : '',
                    }
                )
                cost.quoteId = cost.quoteId ? cost.quoteId : this.cost.quoteId
                cost.costId = cost.costId
                    ? cost.costId
                    : this.cost.costId
                    ? this.cost.costId
                    : this.cost.document_id
                this.cost.engineeringDate = cost.engineeringDate
                this.originalCost.engineeringDate = cost.engineeringDate
                this.engineeringDate = this.formatDate(
                    cost.engineeringDate._seconds ||
                        cost.engineeringDate.seconds
                )
                if (this.costs) {
                    let index = this.costs.findIndex(
                        c => c.id === cost.costId || c.id === cost.id
                    )
                    if (index !== -1) {
                        this.costs.splice(index, 1, {
                            ...this.costs[index],
                            ...cost,
                        })
                    }
                    this.$emit('updateCostInLocal', this.cost)
                    this.spreadCosts(_.cloneDeep(this.costs))
                } else {
                    this.$emit('updateCost', cost)
                }
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading2 = false
            }
        },
        getUserName(id) {
            if (this.users.length > 0 && id) {
                return this.users.find(user => user.id == id)?.name
            } else {
                return ''
            }
        },
        assignNamesToImages(htmlContent) {
            // Find images without data-name and assign names to them
            let updatedContent = htmlContent

            // Replace images without data-name
            updatedContent = updatedContent.replace(
                /<img([^>]*?)src="([^"]+)"([^>]*?)(?:\s+data-name="[^"]*")?([^>]*?)>/g,
                (match, before, src, middle, after) => {
                    // Check if data-name already exists
                    if (match.includes('data-name=')) {
                        return match
                    }

                    // Generate a unique UUID
                    const imageName = uuidv4()

                    return `<img${before}src="${src}"${middle} data-name="${imageName}"${after}>`
                }
            )

            return updatedContent
        },
        namePreDesignTxtFile(reference, versionNumber) {
            const generatedName = `PreDesign_Rejected ${reference} V${versionNumber}.txt`
            return generatedName
        },
        async saveEditorContentToTxt(editorContent, fileName) {
            try {
                const path = `${this.companyId}/quotes/${this.quote.id}/costs/${this.cost.id}/preDesigns`
                const storageRef = storage().ref(path)
                const txtRef = storageRef.child(fileName)

                // Create a blob from the editor content
                const blob = new Blob([editorContent], { type: 'text/plain' })

                // Upload the file
                await txtRef.put(blob)
                return true
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: `Error saving editor content: ${error.message}`,
                })
                return false
            }
        },
        async getImagesDimensions(base64Images) {
            return Promise.all(
                base64Images.map(image => {
                    return new Promise((resolve, reject) => {
                        const img = new Image()
                        img.onload = () => {
                            resolve({
                                src: image.base64,
                                name: image.name,
                                width: img.width,
                                height: img.height,
                            })
                        }
                        img.onerror = () => {
                            reject(
                                `Error loading base64 image: ${image.base64}`
                            )
                        }
                        img.src = image.base64
                    })
                })
            )
        },
        async convertToFiles(imagesWithDimensions) {
            return Promise.all(
                imagesWithDimensions.map(async imageObj => {
                    const { src, width, height, name } = imageObj
                    const file = await this.base64ToFile(src, name)
                    const url = URL.createObjectURL(file)
                    return { src: file, width, height, url, base64: src, name }
                })
            )
        },
        base64ToFile(base64, originalName = null) {
            return new Promise(resolve => {
                const byteString = Uint8Array.from(
                    atob(base64.split(',')[1]),
                    c => c.charCodeAt(0)
                )
                const mimeString = base64
                    .split(',')[0]
                    .split(':')[1]
                    .split(';')[0]

                // Use original name (UUID) if provided, otherwise generate new UUID
                const fileName = originalName || uuidv4()
                const blob = new Blob([byteString], { type: mimeString })
                const file = this.blobToFile(blob, fileName)
                resolve(file)
            })
        },
        blobToFile(blob, fileName) {
            return new File([blob], fileName, {
                type: blob.type,
                lastModified: new Date().getTime(),
            })
        },
        validateRejection() {
            if (this.selectedPreDesign.rejectedDueToError) {
                this.rejectPreDesign()
            } else {
                this.previousEngineeringDate = this.engineeringDate
                this.engineeringDate = ''
                this.minDate = new Date().toISOString()
                this.engineerDateDialog = true
            }
        },

        async rejectPreDesign(newEngineeringDate = null) {
            try {
                this.loading2 = true
                const txtFileName = this.namePreDesignTxtFile(
                    this.cost.reference,
                    this.selectedPreDesign.versionNumber
                )
                const updatedHtml = this.assignNamesToImages(this.editorContent)
                await this.saveEditorContentToTxt(updatedHtml, txtFileName)
                const images = this.extractImagesWithMatchAll(
                    this.editorContent
                )
                let rejectionImages = []
                if (images.length) {
                    const imagesToSave = this.imagesAsFiles.filter(
                        image => !this.originalImages.includes(image.name)
                    )
                    const path = `${this.companyId}/quotes/${this.quote.id}/costs/${this.cost.id}/preDesigns`
                    for (const img of imagesToSave) {
                        await saveFile(img.src, path)
                    }
                    const imagesAsFiles = this.imagesAsFiles
                    for (const img of imagesAsFiles) {
                        const index = this.imagesAsFiles
                            ? this.imagesAsFiles.findIndex(
                                  image =>
                                      image.name == img.src.name ||
                                      image.src.name === img.src.name
                              )
                            : -1
                        if (index > -1) {
                            if (rejectionImages?.length > 0) {
                                rejectionImages.push({
                                    name: img.name ? img.name : img.src.name,
                                    index,
                                })
                            } else {
                                rejectionImages = [
                                    {
                                        name: img.name
                                            ? img.name
                                            : img.src.name,
                                        index,
                                    },
                                ]
                            }
                        }
                    }
                }
                if (this.files.length) {
                    for (const file of this.localAttachments) {
                        await saveFile(
                            file,
                            `${this.companyId}/quotes/${this.quote.id}/costs/${this.cost.id}/preDesigns`
                        )
                    }
                }
                let attachments = []
                if (this.files && this.files.length > 0) {
                    attachments = this.files.map(file => file.name)
                }
                let rejectedOn = new Date().toISOString()
                const cost = await API.rejectPreDesign(
                    this.cost.quoteId,
                    this.cost.document_id
                        ? this.cost.document_id
                        : this.cost.id,
                    {
                        preDesign: {
                            rejectedOn,
                            rejectedBy: this.user.id,
                            rejectionReason: this.selectedPreDesign
                                .rejectionReason,
                            versionNumber: this.selectedPreDesign.versionNumber,
                            file: this.selectedPreDesign.file, //Support for legacy versions
                            rejectedDueToError: this.selectedPreDesign
                                .rejectedDueToError,
                            rejectionNotes: txtFileName,
                            rejectionImages: rejectionImages,
                            rejectionAttachments: attachments,
                        },
                        ...(newEngineeringDate
                            ? { engineeringDate: newEngineeringDate }
                            : {}),
                        engineering: true,
                    }
                )
                if (cost.preDesign) {
                    this.cost.preDesign = cost.preDesign
                }
                if (cost.engineeringDate) {
                    this.cost.engineeringDate = cost.engineeringDate
                    this.engineeringDate = this.formatDate(
                        cost.engineeringDate._seconds ||
                            cost.engineeringDate.seconds
                    )
                }
                delete cost.engineeringIngressDate
                delete cost.engineeringExitDate
                delete cost.preDesignReturned
                delete cost.engIngressBy
                delete cost.engExitBy
                if (this.costs) {
                    let index = this.costs.findIndex(c => c.id === cost.costId)
                    if (index !== -1) {
                        this.costs.splice(index, 1, {
                            ...this.costs[index],
                            ...cost,
                        })
                    }

                    this.cost.engineering = true
                    this.$emit('updateCostInLocal', this.cost)
                    this.spreadCosts(_.cloneDeep(this.costs))
                } else {
                    this.cost.engineering = true
                    this.$emit('updateCost', this.cost)
                }
                if (this.rejectPreDesignDialog) {
                    this.closeRejectPreDesignDialog()
                }
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading2 = false
            }
        },
        formatName(name) {
            const version = name ? name.split(' ').pop() : ''
            return version
        },
        async cancelPreDesignRejection(item) {
            try {
                this.loading2 = true
                const cost = await API.rejectPreDesign(
                    this.cost.quoteId,
                    this.cost.document_id
                        ? this.cost.document_id
                        : this.cost.id,
                    {
                        preDesign: {
                            rejectedOn: '',
                            rejectedBy: '',
                            rejectionReason: '',
                            versionNumber: item.versionNumber,
                        },

                        engineering: false,
                    }
                )
                if (cost.preDesign) {
                    this.cost.preDesign = cost.preDesign
                }
                delete cost.engineeringIngressDate
                delete cost.engineeringExitDate
                delete cost.preDesignReturned
                delete cost.engIngressBy
                delete cost.engExitBy
                if (this.costs) {
                    let index = this.costs.findIndex(c => c.id === cost.costId)
                    if (index !== -1) {
                        this.costs.splice(index, 1, {
                            ...this.costs[index],
                            ...cost,
                        })
                    }

                    this.cost.engineering = false
                    this.$emit('updateCostInLocal', this.cost)
                    this.spreadCosts(_.cloneDeep(this.costs))
                } else {
                    this.cost.engineering = false
                    this.$emit('updateCost', this.cost)
                }
                if (this.rejectPreDesignDialog) {
                    this.closeRejectPreDesignDialog()
                }
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading2 = false
            }
        },
        formatNumber(number) {
            const formatted = new Intl.NumberFormat('de-DE', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(number)
            return formatted
        },
    },
}
</script>

<style scoped>
.no-border {
    border: none !important;
}
.v-textarea >>> textarea {
    line-height: 22px !important;
}
tr:not(:last-child) > td.border-grey {
    border-bottom: thin solid #eeeeee !important;
}
tr:hover {
    background: unset !important;
}
th,
td {
    font-size: 0.875rem !important;
}
.v-data-table >>> table {
    border: thin solid #eeeeee;
}
.v-expansion-panel-content >>> .v-expansion-panel-content__wrap {
    padding: 0;
}
/* Estilos por defecto para el editor de texto enriquecido */
::v-deep .ql-editor {
    font-family: Arial, sans-serif !important;
    font-size: 13px !important;
}
::v-deep .ql-editor.ql-blank::before {
    font-family: Arial, sans-serif !important;
    font-size: 13px !important;
}
</style>
